module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNDIuMTA3IiBoZWlnaHQ9IjM5MC4yNjgiIHZpZXdCb3g9IjAgMCAzNDIuMTA3IDM5MC4yNjgiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NCIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NCIgZD0iTTUxNy4yMzIsMTI1OS44Vjk5OS4yTDg1OS4zMzksODY5LjUzNnYyNjAuNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTcuMjMxIC04NjkuNTM1KSIgZmlsbD0ibGltZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_342.svg
// module id = Rgrl
// module chunks = 0